import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { EventsHistoryComponent } from "./events-history/events-history.component";
import { DataInputLogComponent } from "./data-input-log/data-input-log.component";

import { UserRolePermissionsService } from "src/app/shared/services/user-role-permissions/user-role-permissions.service";

enum HistoryLogState {
  Events = "events",
  Data = "data",
}

@Component({
  selector: "im-history-log",
  imports: [
    MatButtonToggleModule,
    MatCardModule,
    MatProgressSpinnerModule,
    EventsHistoryComponent,
    DataInputLogComponent,
  ],
  templateUrl: "./history-log.component.html",
  styleUrl: "./history-log.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HistoryLogComponent {
  public isGlobalLoading: boolean = false;
  public toggleValue: HistoryLogState = HistoryLogState.Events;

  constructor(public userRoles: UserRolePermissionsService) {}

  public async onHistoryLogStateChange(value: HistoryLogState) {
    if (this.toggleValue != value) this.toggleValue = value;
  }
}
